<template>
    <!-- Desktop: Header + Content -->
    <OnDesktop>
        <StickyHeaderLayout>
            <template #header>
                <HeaderTitle>{{ translate('general.data-collection') }}</HeaderTitle>
                <BreadcrumbNavigation />
            </template>
            <template #default>
                <RouterView />
            </template>
        </StickyHeaderLayout>
    </OnDesktop>

    <!-- Mobile: Content with breadcrumb passed to child layouts -->
    <OnMobile>
        <RouterView />
    </OnMobile>
</template>

<script setup lang="ts">
import OnDesktop from '@/vue/components/design-system/screen/OnDesktop.vue'
import OnMobile from '@/vue/components/design-system/screen/OnMobile.vue'
import HeaderTitle from '@/vue/components/layout/HeaderTitle.vue'
import StickyHeaderLayout from '@/vue/components/layout/StickyHeaderLayout.vue'
import BreadcrumbNavigation from '@/vue/components/navigation/BreadcrumbNav/breadcrumb-navigation.vue'
import { useTranslationsStore } from '@/vue/stores/translationsStore'

const { translate } = useTranslationsStore()
</script>
